<template>
    <span style="margin-bottom:20px;">
        <form-group>
          {{label}}
            <b-row>
                <b-col>
                  <strong>As Of Date:</strong> <span v-if="pcnSema4Attributes"> {{ getSema4AsOfDate() }} </span>
                </b-col>
                <b-col>
                    <strong>Job Option Code:</strong> {{ pcnSema4Attributes.moptionCd }}
                </b-col>
                <b-col>
                    <strong>Hours Per Week:</strong> {{ pcnSema4Attributes.stdHours }}
                </b-col>
            </b-row>
            <b-row>
                <b-col v-if="pcnSema4Attributes">
                    <strong>PCN:</strong> {{ pcnSema4Attributes.posCd }}
                </b-col>
                <b-col v-if="pcnSema4Attributes.length === 0">
                    <strong>PCN:</strong> {{ 'No PCN data found.' }}
                </b-col>
                <b-col>
                    <strong>Job Option Description:</strong> {{ pcnSema4Attributes.wjobOptionLd }}
                </b-col>
                <b-col>
                    <strong>FTE:</strong> {{ pcnSema4Attributes.posFtePct }}
                </b-col>
            </b-row>
            <b-row>
                <b-col>
                    <strong>Dept ID:</strong> {{ pcnSema4Attributes.deptId }}
                </b-col>
                <b-col>
                    <strong>Reports to PCN:</strong> {{ pcnSema4Attributes.reportsTo }}
                </b-col>
                <b-col>
                    <strong>FLSA Status:</strong> {{ pcnSema4Attributes.flsaStatLd }}
                </b-col>
            </b-row>
            <b-row>
                <b-col>
                    <strong>Dept Name:</strong> {{ pcnSema4Attributes.deptLd }}
                </b-col>
                <b-col>
                    <strong>Reg-Temp:</strong> {{ pcnSema4Attributes.regTempLd }}
                </b-col>
                <b-col>
                    <strong>Union Code:</strong> {{ pcnSema4Attributes.unionCd }}
                </b-col>
            </b-row>
            <b-row>
                <b-col>
                    <strong>Work Location:</strong> {{ pcnSema4Attributes.locLd }}
                </b-col>
                <b-col>
                    <strong>Classification Status:</strong> {{ pcnSema4Attributes.clsIndLd }}
                </b-col>
                <b-col> </b-col>
            </b-row>
            <b-row>
                <b-col>
                    <strong>Job Classification:</strong> {{ pcnSema4Attributes.jobcodeLd }}
                </b-col>
                <b-col>
                    <strong>Employment Condition:</strong> {{ pcnSema4Attributes.posFullPtCd }}
                </b-col>
                <b-col> </b-col>
            </b-row>
            <b-row>
                <b-col v-if="fundingData">
                    <strong>PCN Funding Data: </strong> <small> {{ fundingData.isValid }} </small>
                    <b-table-simple hover small caption-top responsive>
                        <b-thead>
                            <b-tr>
                                <b-th>Percent</b-th>
                                <b-th>Fund</b-th>
                                <b-th>Fin Dept ID</b-th>
                                <b-th>Approp ID</b-th>
                                <b-th>Project Description</b-th>
                                <b-th>Activity</b-th>
                                <b-th>Source</b-th>
                              </b-tr>
                        </b-thead>
                        <b-tbody>
                            <b-tr v-for="row in fundingData" :key="row.seqNo">
                                <b-td>
                                    {{ row.distPct }}
                                </b-td>
                                <b-td>
                                    {{ row.fundCode }}
                                </b-td>
                                <b-td>
                                    {{ row.deptidCf }}
                                </b-td>
                                <b-td>
                                    {{ row.chartfield3 }}
                                </b-td>
                                <b-td>
                                    {{ row.projectdescr }}
                                </b-td>
                                <b-td>
                                    {{ row.activityId }}
                                </b-td>
                                <b-td>
                                    {{ row.resourceType }}
                                </b-td>
                            </b-tr>
                        </b-tbody>
                    </b-table-simple>
                </b-col>
            </b-row>
        </form-group>
    </span>
</template>

<script>
import {alphaNum} from "vuelidate/lib/validators";
export default {
    props: {
        label: [String],
        pcnSema4Attributes: {
            asOfDate: String,
            posCd: [String],
            deptId: [String],
            deptLd: [String],
            locLd: [String],
            jobcodeLd: [String],
            moptionCd: [String],
            wjobOptionLd: [String],
            reportsTo: [String],
            regTempLd: [String],
            clsIndLd: [String],
            posFullPtCd: [String],
            stdHours: [String],
            posFtePct: [String],
            flsaStatLd: [String],
            unionCd: [String],

        },
        fundingData: {
            isValid: [String],
            positionNbr: [String],
            distPct: [String],
            fundCode: [String],
            deptidCf: [String],
            chartfield3: [String],
            projectdescr: [String],
            activityId: [String],
            resourceType: [String],
            seqNo: [String]
        },
    },

    methods: {
        getSema4AsOfDate() {
            const today = new Date();
            today.setDate(today.getDate() - 1);
            const date = (today.getMonth()+1) + '/' + today.getDate() + '/' + today.getFullYear();
            return date;
        }
    }

}
</script>
